import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {BillingListComponent} from './billing-list/billing-list.component';


export const billingRoutes: Routes = [
  {
    path: 'billing',
    component: BillingListComponent,
    data: {
      'expectedRoles': ['UIH']
    },
  }
];

@NgModule({
  imports: [RouterModule.forChild(billingRoutes)],
  exports: [RouterModule]
})
export class BillingRoutingModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/billing/billing-routing.module.ts